<template>
  <div class="about">
    <a href="<>HOME_PAGE_URL<>" target="_blank"> <img class="logo" :src="siteMetadata?.mainLogo || logo"> </a>
    <h2 :style="`color: ${getIdealTextColor()}`" v-text="$route.query.title"></h2>
    <h1 :style="`color: ${getIdealTextColor()}`" v-text="$route.query.message"></h1>

    <div class="img-side-by" v-if="siteMetadata?.hasOwnApp">
      <a v-if="siteMetadata?.appStoreLink" :href="siteMetadata?.appStoreLink" ><img :src="logoAppStore" :alt="logoAppStore"></a>
      <a v-if="siteMetadata?.playStoreLink" :href="siteMetadata?.playStoreLink" ><img :src="logoPlayStore" :alt="logoPlayStore"></a>
    </div>
  </div>
</template>

<script>
import { idealTextColor } from '@/controllers/libs/Util.js'
import { mapGetters } from 'vuex'

export default {
    name: 'AboutView',
    props: {
        message: String
    },
    data () {
        return {
            logo: '',
            logoPlayStore: require('@/assets/playStore.png'),
            logoAppStore: require('@/assets/appStore.png')
        }
    },
    computed: {
        ...mapGetters(['siteMetadata'])
    },
    methods: {
        getIdealTextColor: function () {
            return idealTextColor()
        }
    }
}
</script>

<style lang="less">
.logo {
    object-fit: contain;
    max-width: 100%;
    max-height: 70px;
    max-height: 170px;
    display: block;
    margin: auto;
    &.thumb{
        max-height: 100px;
        margin: auto auto 0 auto;
    }
}
.about {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(calc(-50% - 15px), calc(-50% - 15px));

  .img-side-by {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 30px;
    max-width: 100%;
    img {
      display: block;
      max-width: 100%;
      pointer-events: none;
      margin: auto;
    }
    a {
      display: block;
    }
  }
}

.about+.powered-by {
  position: fixed;
  bottom: 0;
}
@media (max-width:960px) {
  .about {
    width: 95%;
    transform: translate(-50%, -50%);
    .img-side-by {
      display: block;
      margin: 80px auto 0 auto;
      img{
        display: block;
        margin: 5px auto;
      }
    }
  }
}
</style>
